let eventdata = [
    {
        id:1,
        name: 'Sovereign of Spies',
        timing: 'April, 2022',
        imgsource: 'sos.png',
        desc: "A Treasure Hunt like event that involves a Spy Universe Storyline. Participants had to gather parts to diffuse a ticking nuclear weapon through the medium of clues provided by QR Codes placed across the Campus. Participants has to complete a task in order to recieve the clue. "
    },
    {
        id:2,
        name: 'The Tridents Odyssey',
        timing: 'November, 2022',
        imgsource: 'tto.png',
        desc: "A Capture the flag-esque event that invloves a Pirate Universe Storyline. Participants had to capture the flags placed across the campus through QR Codes both Enemy and Home. This entire process was tracked LIVE via a simple but elegant Database System designed by our own team. The system could handle 300+ inputs at once. So the participants were playing a full fledged action game but in real life."
    }, 
    {
        id:3,
        name: 'Sherlock',
        timing: 'November, 2022',
        imgsource: 'sherlock.png',
        desc: "As the name suggests this event involves desinging a thick but solvable plot which must be solved by the particpants. The entire mystery storyline is explained through various evidences. Further rounds involve setting up an actual crime scene scenario. The design of the event is difficult than others as the organizers must think of all the possible cases that might occur."
    }, 
    {
        id:4,
        name: 'Big Tech Debate',
        timing: 'June, 2022',
        imgsource: 'btd.png',
        desc: "The Biggest event at Daksh with maximum sponsors due to its formal and technical nature. Particpants go through several stages of selection via Bidding-Auction, Stock Market Analysis and finally the Debate itself. Current Affairs and intriguing Tech topics are introduced at each stage. The event is meant to set up an example as to how a formal and civilized debate must be conducted."
    },
]

export default eventdata;